module.exports = __webpack_public_path__ + "media/kpi-mote.f83f10de.mp4";